export default "__VITE_ASSET__DUuEvKTl__"